import {isFullSwing} from "../../constants";

const defaultLayout = {
  mobileMax: 440, mobileGutter: 20, navHeight: 72, sectionGap: 24, stackTight: 12, buttonLgHeight: 52,
  buttonLgPaddingHorizontal: 28, flowHeaderPaddingTop: 10, flowHeaderPaddingHorizontal: 8, flowHeaderPaddingBottom: 8,
  flowHeaderButton: 44, flowHeaderHeadMarginTop: 12, flowHeaderHeadGap: 28, flowHeaderTitleSize: 28, stepDotGap: 6,
  stepDotWidth: 24, stepDotActiveWidth: 36, stepDotHeight: 4, methodGap: 10, rowGap: 12, buttonRadius: 999
};

const defaultColors = {
  bg: '#0e2424', headerBg: '#0e2424', bgElev1: '#143030', bgInset: '#0a1c1c', textPrimary: '#ffffff',
  textSecondary: '#97a8a6',
  textMuted: '#6e817f', accent: '#27e9a6', accentText: '#27e9a6', accentInk: '#1b3131',
  accentSoft: 'rgba(39, 233, 166, 0.1)',
  accentSoftStrong: 'rgba(39, 233, 166, 0.2)', hairline: 'rgba(235, 255, 247, 0.08)',
  hairlineStrong: 'rgba(235, 255, 247, 0.16)', surfaceBorder: 'rgba(235, 255, 247, 0.08)',
  hairlineStrongOnSignatureBg: '#415251', signatureBg: '#1b3131', signatureSummary: 'rgba(10, 28, 28, 0.7)',
  statusSuccess: '#27e9a6', statusSuccessSoft: 'rgba(39, 233, 166, 0.16)',
  statusSuccessBurst: 'rgba(39, 233, 166, 0.18)', statusSuccessBorder: 'rgba(39, 233, 166, 0.2)',
  statusWarn: '#f5b441',
  statusWarnSoft: 'rgba(245, 180, 65, 0.14)',
  statusLost: '#ff6b6b', statusLostSoft: 'rgba(255, 107, 107, 0.1)'
};

const fullSwingColors: typeof defaultColors = {
  bg: '#131314', headerBg: '#252526', bgElev1: '#252526', bgInset: '#1B1B1C', textPrimary: '#ffffff',
  textSecondary: '#BBBCBF',
  textMuted: '#96979A', accent: '#3369FF', accentText: '#6F91FF', accentInk: '#ffffff',
  accentSoft: 'rgba(51, 105, 255, 0.1)', accentSoftStrong: 'rgba(51, 105, 255, 0.2)', hairline: '#494A4C',
  hairlineStrong: '#76777A', surfaceBorder: '#76777A', hairlineStrongOnSignatureBg: '#76777A',
  signatureBg: '#131314', signatureSummary: '#252526', statusSuccess: '#6F91FF',
  statusSuccessSoft: 'rgba(51, 105, 255, 0.16)', statusSuccessBurst: 'rgba(51, 105, 255, 0.18)',
  statusSuccessBorder: 'rgba(111, 145, 255, 0.32)',
  statusWarn: '#f5b441', statusWarnSoft: 'rgba(245, 180, 65, 0.14)', statusLost: '#ff6b6b',
  statusLostSoft: 'rgba(255, 107, 107, 0.1)'
};

export const getWithdrawFlowTheme = (fullSwing: boolean) => ({
  colors: fullSwing ? fullSwingColors : defaultColors,
  layout: fullSwing ? {...defaultLayout, buttonRadius: 4} : defaultLayout,
  signaturePattern: fullSwing ? 'fullSwing' as const : 'evenplay' as const
});

const activeTheme = getWithdrawFlowTheme(isFullSwing);

export const colors = activeTheme.colors;
export const layout = activeTheme.layout;
export const signaturePattern = activeTheme.signaturePattern;

export const totalSteps = 4;
export const missingApiValue = 'TBD';
